import TagManager from "react-gtm-module";

export function useTagManager() {
  function dataLayerOmega(dataLayer: { [key: string]: unknown }) {
    TagManager.dataLayer({
      dataLayer,
      dataLayerName: "omegaDataLayer",
    });
  }

  function dataLayer(dataLayer: { [key: string]: unknown }) {
    TagManager.dataLayer({
      dataLayer,
    });

    dataLayerOmega(dataLayer);
  }

  return { dataLayer, dataLayerOmega };
}
